/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { getEmbeddedResource, getUrl } from '@ngxp/rest';
import { VorgangListLinkRel } from '../vorgang.linkrel';
import { VorgangListResource, VorgangResource } from '../vorgang.model';

export function getSelectedVorgangPage(
  selectedVorgangUri: string,
  vorgangList: VorgangListResource,
  vorgangListNextPage: VorgangListResource,
): number {
  if (isVorgangInList(selectedVorgangUri, vorgangList)) return getVorgangListPage(vorgangList);
  if (isVorgangInList(selectedVorgangUri, vorgangListNextPage)) return getVorgangListPage(vorgangListNextPage);
  return undefined;
}

function isVorgangInList(vorgangUri: string, vorgangList: VorgangListResource): boolean {
  if (!vorgangList) return false;
  return getEmbeddedResource<VorgangResource[]>(vorgangList, VorgangListLinkRel.VORGANG_HEADER_LIST).some(
    (vorgang: VorgangResource) => getUrl(vorgang) === vorgangUri,
  );
}

function getVorgangListPage(vorgangList: VorgangListResource): number {
  if (vorgangList._links[VorgangListLinkRel.NEXT]) {
    const url: URL = new URL(getUrl(vorgangList, VorgangListLinkRel.NEXT));
    return parseInt(url.searchParams.get('page')) - 1;
  } else if (vorgangList._links[VorgangListLinkRel.PREV]) {
    const url: URL = new URL(getUrl(vorgangList, VorgangListLinkRel.PREV));
    return parseInt(url.searchParams.get('page')) + 1;
  }
  return 0;
}
